module.exports = __webpack_public_path__ + "img/ic_icon_cvu_dni3.e072d433.png";